import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: {
      path:'/home'
    }
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta:{
      title:'网站首页'
    },
  },
  {
    path: '/introduction',
    name: 'CompanyIntroduction',
    component: () => import('../views/company_introduction.vue'),
    meta:{
      title:'公司介绍'
    },
  },
  {
    path: '/business_index',
    name: 'BusinessIndex',
    component: () => import('../views/business_index.vue'),
    redirect: '/business_index/business',
    children:[
      {
        path: '/business_index/business',
        name: 'MainBusiness',
        component: () => import('../views/main_business.vue'),
        meta:{
          title:'主营业务'
        },
      },
      // 运营
      {
        path: '/business_index/operation',
        name: 'Operation',
        component: () => import('../views/child_pages/operation.vue'),
        meta:{
          title:'店铺运营'
        },
      },
      // 直播
      {
        path: '/business_index/live',
        name: 'Live',
        component: () => import('../views/child_pages/live.vue'),
        meta:{
          title:'内容直播'
        },
      },
      // 视觉设计
      {
        path: '/business_index/vision',
        name: 'Vision',
        component: () => import('../views/child_pages/vision.vue'),
        meta:{
          title:'视觉设计'
        },
      },
      // 客服
      {
        path: '/business_index/service',
        name: 'Service',
        component: () => import('../views/child_pages/service.vue'),
        meta:{
          title:'客服服务'
        },
      },
      // 营销
      {
        path: '/business_index/mark',
        name: 'Mark',
        component: () => import('../views/child_pages/mark.vue'),
        meta:{
          title:'数字营销'
        },
      },
      // 物流
      {
        path: '/business_index/logistic',
        name: 'Logistic',
        component: () => import('../views/child_pages/logistic.vue'),
        meta:{
          title:'物流仓储'
        },
      },
    ]
  },
  {
    path: '/cooperation_brand',
    name: 'CooperationBrand',
    component: () => import('../views/cooperation_brand.vue'),
    meta:{
      title:'合作品牌'
    },
  },
  {
    path: '/cooperation_business',
    name: 'CooperationBusiness',
    component: () => import('../views/cooperation_business.vue')
  }
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
